import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import * as snackbarActions from "../../actions/snackbarActions";
import { config } from "../../Helpers/env";
import { LoadingGif } from "../Utils/Loader";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import PageTitle from "../Utils/smsTitle";
import { SubHeader } from "../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPills,
  faFileExcel,
  faFilePdf,
  faRocket,
  faHourglassHalf,
  faSkullCrossbones,
  faChartLine
} from "@fortawesome/free-solid-svg-icons";
import { BackButton } from "../Utils/Buttons/DataExportationButton";
import { Container } from "../Utils/styledComponents";

const StockMovementReport = ({ actions, snackbars }) => {
  const today = new Date().toISOString().slice(0, 10);
  const firstDayOfMonth = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    1
  )
    .toISOString()
    .slice(0, 10);

  const [filters, setFilters] = useState({
    start_date: firstDayOfMonth,
    end_date: today
  });
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [activeTab, setActiveTab] = useState("top");

  const fetchReport = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);

      const res = await axios.get(
        `${config.smsUrl}/creport/stock_movement_report`,
        { params }
      );
      setReport(res.data);
    } catch (err) {
      actions.snackbarActions.errorSnackbar?.("Failed to load report");
      setReport(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, [filters.start_date, filters.end_date]);

  const {
    summary = {},
    top_selling_products = [],
    medium_moving_products = [],
    dead_stock_products = []
  } = report || {};

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString("en-GB") : "-";

  const formatSSP = (amount) =>
    `SSP ${Number(amount || 0).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`;

  const formatUSD = (amount) =>
    `$${Number(amount || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;

  const totalSSP = summary.total_revenue_ssp || 0;
  const totalUSD = summary.total_revenue_usd || 0;

  return (
    <Container className="mt-1">
      <PageTitle title="Stock Movement Report" />
      <SubHeader title="Reports" subTitle="Stock Movement Analysis • SSP + USD">
        <FontAwesomeIcon icon={faPills} />
      </SubHeader>

      <MainSnackbar
        open={snackbars?.openBar}
        variant={snackbars?.type}
        message={snackbars?.message}
        handleCloseBar={actions.snackbarActions.hideSnackbar}
      />
{/* ===== TOP SECTION – keep this together ===== */}
<div style={{ padding: "8px 12px 0 12px" }}>
  {/* Back button */}
  <div style={{ marginBottom: "10px" }}>
    <BackButton to="/reports/generalreports" text="Reports" />
  </div>

  {/* Filters – no card, no big padding */}
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "8px",
      marginBottom: "16px"
    }}
  >
    <input
      type="date"
      className="form-control form-control-sm"
      value={filters.start_date}
      onChange={(e) =>
        setFilters({ ...filters, start_date: e.target.value })
      }
      style={{
        width: "145px",
        height: "32px",
        padding: "2px 8px",
        fontSize: "13px"
      }}
    />

    <input
      type="date"
      className="form-control form-control-sm"
      value={filters.end_date}
      onChange={(e) =>
        setFilters({ ...filters, end_date: e.target.value })
      }
      style={{
        width: "145px",
        height: "32px",
        padding: "2px 8px",
        fontSize: "13px"
      }}
    />

    <button
      type="button"
      onClick={fetchReport}
      disabled={loading}
      className="btn btn-sm text-white"
      style={{
        backgroundColor: "#389081",
        borderColor: "#389081",
        height: "32px",
        padding: "0 14px",
        fontSize: "13px"
      }}
    >
      {loading ? "Loading..." : "Refresh"}
    </button>

    <button
      type="button"
      className="btn btn-sm text-white"
      style={{
        backgroundColor: "#389081",
        borderColor: "#389081",
        height: "32px",
        padding: "0 14px",
        fontSize: "13px"
      }}
    >
      <FontAwesomeIcon icon={faFileExcel} className="me-1" />
      Excel
    </button>

    <button
      type="button"
      className="btn btn-sm text-white"
      style={{
        backgroundColor: "#389081",
        borderColor: "#389081",
        height: "32px",
        padding: "0 14px",
        fontSize: "13px"
      }}
    >
      <FontAwesomeIcon icon={faFilePdf} className="me-1" />
      PDF
    </button>
  </div>
</div>
{/* ===== END TOP SECTION ===== */}

      {/* Summary Cards – system colors */}
      <div className="row g-3 mb-4">
        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #389081, #027a5f)" }}
          >
            <div className="card-body text-center py-3">
              <FontAwesomeIcon icon={faRocket} className="mb-2 opacity-75" />
              <h6 className="mb-1 opacity-75">Top Selling</h6>
              <h3 className="mb-0 fw-bold">{summary.top_selling || 0}</h3>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #08819c, #0a6b7a)" }}
          >
            <div className="card-body text-center py-3">
              <FontAwesomeIcon
                icon={faHourglassHalf}
                className="mb-2 opacity-75"
              />
              <h6 className="mb-1 opacity-75">Medium Moving</h6>
              <h3 className="mb-0 fw-bold">{summary.medium_moving || 0}</h3>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #F76B1D, #e05a0d)" }}
          >
            <div className="card-body text-center py-3">
              <FontAwesomeIcon
                icon={faSkullCrossbones}
                className="mb-2 opacity-75"
              />
              <h6 className="mb-1 opacity-75">Dead Stock</h6>
              <h3 className="mb-0 fw-bold">{summary.dead_stock || 0}</h3>
            </div>
          </div>
        </div>

        <div className="col-6 col-md-3">
          <div
            className="card border-0 shadow-sm text-white"
            style={{ background: "linear-gradient(135deg, #3e3e3e, #2b2a2a)" }}
          >
            <div className="card-body text-center py-3">
              <FontAwesomeIcon icon={faChartLine} className="mb-2 opacity-75" />
              <h6 className="mb-1 opacity-75">Total Revenue</h6>
              <div className="small">{formatSSP(totalSSP)}</div>
              <div className="fw-bold">{formatUSD(totalUSD)}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "top" ? "active" : ""}`}
            onClick={() => setActiveTab("top")}
          >
            Top Selling ({top_selling_products.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "medium" ? "active" : ""}`}
            onClick={() => setActiveTab("medium")}
          >
            Medium Moving ({medium_moving_products.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "dead" ? "active" : ""}`}
            onClick={() => setActiveTab("dead")}
          >
            Dead Stock ({dead_stock_products.length})
          </button>
        </li>
      </ul>

      {loading && (
        <div className="text-center py-5">
          <LoadingGif />
        </div>
      )}

      {/* TOP SELLING TABLE */}
      {!loading && activeTab === "top" && (
        <div className="table-responsive">
          {top_selling_products.length > 0 ? (
            <table className="table table-hover align-middle">
              <thead style={{ backgroundColor: "#e8f5f3" }}>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Generic</th>
                  <th className="text-end">Qty Sold</th>
                  <th className="text-center">Times Sold</th>
                  <th className="text-end">Revenue (SSP)</th>
                  <th className="text-end">Revenue (USD)</th>
                  <th className="text-center">Avg/Day</th>
                  <th>Last Sale</th>
                  <th className="text-end">Stock</th>
                </tr>
              </thead>
              <tbody>
                {top_selling_products.map((item, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      <strong>{item.product_name}</strong>
                    </td>
                    <td className="text-muted small">
                      {item.generic_name || "-"}
                    </td>
                    <td className="text-end fw-bold">{item.qty_sold}</td>
                    <td className="text-center">{item.times_sold}</td>
                    <td className="text-end">{formatSSP(item.revenue_ssp)}</td>
                    <td className="text-end">{formatUSD(item.revenue_usd)}</td>
                    <td className="text-center">
                      {Number(item.avg_daily_sale || 0).toFixed(2)}
                    </td>
                    <td>{formatDate(item.last_sale_date)}</td>
                    <td className="text-end">{item.current_stock}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-4 text-muted">
              No top selling products found
            </div>
          )}
        </div>
      )}

      {/* MEDIUM MOVING */}
      {!loading && activeTab === "medium" && (
        <div className="row g-3">
          {medium_moving_products.length > 0 ? (
            medium_moving_products.map((item, i) => (
              <div key={i} className="col-lg-4 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <h6 className="fw-bold mb-1">{item.product_name}</h6>
                    <small className="text-muted">
                      {item.generic_name || "—"}
                    </small>
                    <hr className="my-2" />
                    <div className="small">
                      <div>
                        <strong>Qty Sold:</strong> {item.qty_sold}
                      </div>
                      <div>
                        <strong>Revenue:</strong>{" "}
                        {formatSSP(item.revenue_ssp)} →{" "}
                        {formatUSD(item.revenue_usd)}
                      </div>
                      <div>
                        <strong>Last Sale:</strong>{" "}
                        {formatDate(item.last_sale_date)}
                      </div>
                      <div>
                        <strong>Stock:</strong> {item.current_stock}
                        {item.expired_qty > 0 && (
                          <span className="text-danger ms-1">
                            (Expired: {item.expired_qty})
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-4 text-muted">
              No medium moving products found
            </div>
          )}
        </div>
      )}

      {/* DEAD STOCK */}
      {!loading && activeTab === "dead" && (
        <div className="row g-3">
          {dead_stock_products.length > 0 ? (
            dead_stock_products.map((item, i) => (
              <div key={i} className="col-lg-4 col-md-6">
                <div
                  className="card border-0 shadow-sm text-white h-100"
                  style={{
                    background: "linear-gradient(135deg, #c0392b, #e74c3c)"
                  }}
                >
                  <div className="card-body">
                    <h6 className="fw-bold mb-1">
                      <FontAwesomeIcon
                        icon={faSkullCrossbones}
                        className="me-2"
                      />
                      {item.product_name}
                    </h6>
                    <small>{item.generic_name || "—"}</small>
                    <hr className="border-light opacity-50 my-2" />
                    <div className="small">
                      <div className="fw-bold">
                        No sale in{" "}
                        {item.days_inactive === 99999
                          ? "Ever"
                          : `${item.days_inactive} days`}
                      </div>
                      <div>
                        Stock: <strong>{item.current_stock}</strong>
                      </div>
                      {item.expired_qty > 0 && (
                        <div className="mt-1">
                          <strong>EXPIRED: {item.expired_qty}</strong>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-4 text-muted">
              No dead stock products found
            </div>
          )}
        </div>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({ snackbars: state.snackbar });
const mapDispatchToProps = (dispatch) => ({
  actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) }
});

export default connect(mapStateToProps, mapDispatchToProps)(StockMovementReport);